import { render, staticRenderFns } from "./PurchaseJournal.vue?vue&type=template&id=11802d86"
import script from "./PurchaseJournal.vue?vue&type=script&lang=js"
export * from "./PurchaseJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports